import { Chip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AuthBundleChip({ item, onRemove }) {
    const style = getStyle()

    return (
        <Chip
            icon={<Iconify icon={style.icon} width={15} />}
            label={item.label}
            onDelete={handleDelete}
            variant="filled"
            sx={{
                bgcolor: style.bgcolor,
                color: style.color,
                fontWeight: 600,
                fontFamily: style.fontFamily,
                "& .MuiChip-icon": { color: style.color },
            }}
            data-cy={`auth-bundle-chip-${item.type}`}
        />
    )

    function handleDelete() {
        onRemove(item.value)
    }

    function getStyle() {
        if (item.type === "feature") {
            return {
                icon: "eva:flag-fill",
                bgcolor: "primary.lighter",
                color: "primary.darker",
                fontFamily: "Sometype Mono, monospace",
            }
        }
        if (item.type === "scheduleType") {
            return { icon: "mdi:calendar-clock", bgcolor: "warning.lighter", color: "warning.darker" }
        }
        return { icon: "mdi:shield-key-outline", bgcolor: "background.neutral", color: "text.secondary" }
    }
}
